import axios from "axios";
import { StockAnalystsBasics, StockAnalystsRecent, StockAnalystsRecentHeaders } from "@/models/stock-analysts";
import { List, ListQueryParams } from "@/models/table";

export const getStockAnalystsRecent = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, universe_id, next_page_url } = params;

    const url = next_page_url || `/API/v2/id/${universe_id}/analyst/list/recent?&dgformat`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options };

    const res = await axios.get<List<StockAnalystsRecent, StockAnalystsRecentHeaders>>(url, {
        params: {
            ...defaultParams,
        },
    });

    return res.data;
};

export const getStockAnalystsBasics = async (id: number) => {
    const res = await axios.get<StockAnalystsBasics>(`/API/v2/id/${id}/analyst/basics`);

    return res.data;
};

export const getStockAnalystsEstimatesEPS = async (stock: number, from: string, to?: string) => {
    const res = await axios.get<{ estimates_eps_12mfwd: [number, number][]; obfuscated?: boolean; ts_shortened?: boolean }>(`/API/stock/${stock}/estimates/eps/12mfwd`, {
        params: {
            stock,
            from,
            to,
        },
    });

    return res.data;
};

export const getAnalystOpinions = async (tradingitemId: number) => {
    const res = await axios.get<{ bull_case: string; bear_case: string; source_updated_at: string; obfuscated?: boolean }>(`/interface/api/tradingitem/${tradingitemId}/analyst-opinions`);

    return res.data;
};

export const getStockAnalystsTargetPrice = async (stock: number, from: string, to?: string) => {
    const res = await axios.get<{ target_price: [number, number][]; obfuscated?: boolean; ts_shortened?: boolean }>("/API/estimate_consensus_ts", {
        params: {
            stock,
            from,
            to,
        },
    });

    return res.data;
};
